import React from 'react'
import PropTypes from 'prop-types'

const BonusHistory = ({ bonuses, t, isLoading, hasError }) => {
  const renderBonuses = (bonuses) => (
    <div className="tableComponent w-100 mt-4">
      <table className="tableComponent_table">
        <thead>
          <tr>
            <th>{t['tcnext.date_created']}</th>
            <th>{t['tcnext.bonus_reason']}</th>
            <th>{t['tcnext.points_earned']}</th>
          </tr>
        </thead>
        <tbody>
          {bonuses.map((bonus, index) => (
            <tr key={bonus.id || `bonus-${index}`}>
              <td>{bonus.created_at.slice(0, 10)}</td>
              <td>{bonus.adjusted_because}</td>
              <td>{bonus.bonus_points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )

  if (hasError) {
    return <div>{t['tcnext.failed_to_fetch_bonus_history']}</div>
  }

  if (isLoading) {
    return <div>{t['tcnext.loading']}...</div>
  }

  return bonuses ? renderBonuses(bonuses) : null
}

BonusHistory.propTypes = {
  bonuses: PropTypes.array,
  hasError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  t: PropTypes.object.isRequired,
}

export default BonusHistory
